export const VOICE_WEBRTC_REMOTE_MEDIA_ELEMENT_ID = 'voice-remote-media';

export const VOICE_WEBRTC_CLIENT_OPTIONS = Object.freeze({
  ringbackFile: undefined,
  ringtoneFile: undefined
});
